// @flow
import { _get, _post } from "./methods";

export default {
  list: () => _get("/admin/whats-on/sources"),
  saveVenue: (params: any) => _post("/admin/whats-on/venues", params)
};
